import React from 'react';

const ReviewSection = ({ title, children }) => (
  <div className="bg-slate-50 rounded-lg p-3 border">
    <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">{title}</h4>
    <div className="space-y-1">{children}</div>
  </div>
);

const ReviewRow = ({ label, value }) => (
  <div className="flex justify-between text-sm">
    <span className="text-slate-500">{label}</span>
    <span className="font-medium text-slate-800">{value}</span>
  </div>
);

const SignupReviewStep = ({ form }) => {
  const taxonomyDisplay =
    form.taxonomy_code === 'other' ? form.taxonomy_other : form.taxonomy_code;
  const addressLine = `${form.street1}${form.street2 ? ', ' + form.street2 : ''}, ${form.city}, ${form.state} ${form.zip_code}`;
  const contactDisplay = `${form.contact_name}${form.contact_title ? ' (' + form.contact_title + ')' : ''}`;
  const hasSandata = form.sandata_provider_id || form.sandata_provider_code;

  return (
    <div className="space-y-4" data-testid="step-5-review">
      <ReviewSection title="Agency Information">
        <ReviewRow label="Legal Name" value={form.agency_name} />
        {form.dba_name && <ReviewRow label="DBA" value={form.dba_name} />}
        <ReviewRow label="NPI" value={form.npi} />
        <ReviewRow label="Tax ID" value={form.tax_id} />
        {form.medicaid_provider_id && (
          <ReviewRow label="Medicaid Provider ID" value={form.medicaid_provider_id} />
        )}
        {form.taxonomy_code && <ReviewRow label="Taxonomy" value={taxonomyDisplay} />}
      </ReviewSection>

      {hasSandata && (
        <ReviewSection title="Sandata EVV">
          {form.sandata_provider_id && (
            <ReviewRow label="Provider ID" value={form.sandata_provider_id} />
          )}
          {form.sandata_provider_code && (
            <ReviewRow label="Provider Code" value={form.sandata_provider_code} />
          )}
          {form.sandata_medicaid_id && (
            <ReviewRow label="Medicaid ID" value={form.sandata_medicaid_id} />
          )}
          {form.sandata_api_username && (
            <ReviewRow label="API Username" value={form.sandata_api_username} />
          )}
        </ReviewSection>
      )}

      <ReviewSection title="Address & Contact">
        <ReviewRow label="Address" value={addressLine} />
        {form.county && <ReviewRow label="County" value={form.county} />}
        <ReviewRow label="Contact" value={contactDisplay} />
        <ReviewRow label="Phone" value={form.contact_phone} />
        <ReviewRow label="Email" value={form.contact_email} />
      </ReviewSection>

      <ReviewSection title="Admin Account">
        <ReviewRow label="Name" value={form.admin_name} />
        <ReviewRow label="Email" value={form.admin_email} />
      </ReviewSection>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-4">
        <p className="text-xs text-amber-800 font-medium">
          After signup, your agency will be in "Pending Approval" status. AZAI will review
          and activate your account.
        </p>
      </div>
    </div>
  );
};

export default SignupReviewStep;
